// @flow strict
import * as React from 'react'

export type Source = {
  // The list of images the browser can choose from for that breakpoint
  // including their export width e.g. https://fillmurray.com/640/320 640w
  // Useful for resolution switching
  srcSet: string,
  // Art direction: which breakpoints should the browser start picking sources from?
  // e.g. (min-width: 48em)
  media?: string,
  // Browser hints: how much screen size does the image occupy?
  // e.g. 50vw (50% of your device window)
  sizes?: string,
  type?: string,
}

export type Props = {
  alt?: ?string,
  className?: string,
  sources: Source[],
  defaultImage: string,
}

const ResponsiveImage = ({
  sources,
  className,
  alt = '',
  defaultImage,
}: Props) => (
  <picture className={className}>
    {sources.map(({ srcSet, media = '', sizes = '', type }) => (
      <source
        srcSet={srcSet}
        media={media}
        sizes={sizes}
        key={`${srcSet}-${media}`}
        type={type}
      />
    ))}
    <img src={defaultImage} alt={alt} />
  </picture>
)

export default ResponsiveImage
